<template>
    <eventi-edit-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" :titoloEvento="titoloEvento" @update="onUpdateJsonData">
        <template slot="tab-content-event">
            <dati-clinico-strumentali-ictus-edit-component :jsonData="jsonData" @update="onUpdateJsonData"></dati-clinico-strumentali-ictus-edit-component>
        </template>
    </eventi-edit-component>
</template>
<script>
import EventiEditComponent from "../../../base/components/EventiEditComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixins from "../../../../../utility/UtilityMixin";
import DatiClinicoStrumentaliIctusEditComponent from "./DatiClinicoStrumentaliIctusEditComponent.vue";
export default {
    mixins: [UtilityMixins],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { DatiClinicoStrumentaliIctusEditComponent, EventiEditComponent },
    data() {
        return {
            linkback: null,
            titoloEvento: "Dati Clinico-Strumentali Ictus",
            pathResource: "/cardiodaticlinicistrumentaliictus",
            pathRestValidation: "/validation",
            id: "-1",
            isFirmato: false,
            childKey: 0,
            tabIndex: 0,
            showModalLoading: false,
            jsonData: {
                dataEvento: null,
                ospedsino: null,
                sint1: null,
                sint2: null,
                sint3: null,
                sint4: null,
                sint5: null,
                sint6: null,
                sint7: null,
                durata: null,
                conferma: null,
            },
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    methods: {
        onFirmaUpdate() {
            let me = this;
            me.loadData();
        },
        onUpdateFile() {
            let me = this;
            me.childKey++;
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
    },
};
</script>
<style scoped>
.ft-space {
    margin-top: 10px;
}
</style>
